import * as React from 'react'

const PricingProcessBig = (props) => (
  <svg
    width={96}
    height={85}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 48C8 25.92 25.92 8 48 8s40 17.92 40 40-17.92 40-40 40S8 70.08 8 48Zm45.64 26.68v-2.32c6.96-1.32 12.44-5.32 12.52-12.64 0-10.08-8.64-13.56-16.72-15.64-8.08-2.08-10.68-4.28-10.68-7.64 0-3.84 3.6-6.56 9.6-6.56 5.04 0 7.56 1.96 8.48 5 .4 1.44 1.6 2.48 3.08 2.48h1.04c2.36 0 4.04-2.32 3.24-4.52-1.52-4.24-5-7.68-10.52-9.04v-2.48c0-2.92-2.4-5.32-5.32-5.32h-.04C45.4 16 43 18.4 43 21.32v2.4c-6.88 1.48-12.44 5.96-12.44 12.84 0 8.2 6.8 12.28 16.72 14.68 8.92 2.12 10.68 5.24 10.68 8.56 0 2.44-1.76 6.36-9.6 6.36-5.84 0-8.88-2.08-10.04-5.08-.56-1.4-1.76-2.4-3.24-2.4h-.96c-2.4 0-4.12 2.44-3.2 4.64 2 4.92 6.72 7.84 12.04 8.96v2.4c0 2.92 2.4 5.32 5.32 5.32h.04c2.92 0 5.32-2.4 5.32-5.32Z"
      fill="#fff"
      opacity={0.32}
    />
  </svg>
)

export default React.memo(PricingProcessBig)
